<template>
    <div class="col-12 lender-rate-card">
        <div class="lender-logo-wrapper">
            <img :src="lender.logo_url" :alt="lender.name + ' lender-logo'" />
        </div>

        <div class="lender-info-wrapper">
            <span class="lender-info-value">{{ lender.rates }}</span>
            <span class="lender-info-label t-small">{{ $t('ratesTable.repApr.label') }}</span>
        </div>

        <div class="lender-info-wrapper">
            <span class="lender-info-value">{{ lender.loan_amounts }}</span>
            <span class="lender-info-label t-small">{{ $tc('ratesTable.loanAmounts', 2) }}</span>
        </div>

        <div class="lender-button-wrapper">
            <a :class="['button secondary rates-table-button', { poland: territory == 'pol' }]" @click="checkRates">
                {{ $t('ratesTable.checkMyRates') }}
            </a>
        </div>
    </div>
</template>

<script>
import { url } from '@js/utilities/url.js'

export default {
    props: {
        lender: {
            default: {},
        },
    },

    data() {
        return {
            loading: false,
            errors: [],
        }
    },
    methods: {
        checkRates: function () {
            this.trackEvent('event', {
                eventCategory: 'button',
                eventAction: 'click',
                eventLabel: 'check-my-rate',
                eventValue: this.lender.name,
            })

            const location = this.$router.resolve({
                name: 'apply',
            })

            window.location = url(location.href)
        },
    },
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.lender-rate-card {
    background: var(--white);
    border: 1px solid #e5e5e5;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.04);
    height: rem(120px);
    border-radius: 4px;
    margin-bottom: 8px;
    font-weight: bold;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-around;

    @media screen and (max-width: $bp-medium) {
        height: rem(145px);
        flex-wrap: wrap;
    }

    .lender-logo-wrapper {
        max-height: rem(80px);
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;

        @media screen and (max-width: $bp-medium) {
            width: 30%;
        }

        img {
            max-width: 100%;
            max-height: 60px;
        }
    }

    .lender-info-wrapper {
        width: 25%;
        font-size: rem(19px);
        line-height: rem(23px);
        letter-spacing: -0.02em;
        text-align: left;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: $bp-medium) {
            width: 30%;
        }

        .lender-info-value {
            color: var(--text-offer-example);
        }

        .lender-info-label {
            line-height: rem(17px);
            letter-spacing: 0.01em;
            text-align: left;
            color: var(--text-default);
        }
    }

    .lender-button-wrapper {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (max-width: $bp-medium) {
            width: 100%;
        }

        .rates-table-button {
            color: var(--cta-form-button-text-color);
            cursor: pointer;
            height: rem(52px);
            width: rem(142px);
            border-radius: 4px;
            font-size: rem(15px);
            line-height: rem(52px);
            letter-spacing: 0.01em;
            text-align: center;
            border: none;
            padding: 0;

            &.poland {
                height: initial;
                line-height: rem(18px);
                padding: 8px 0px;
                width: 100%;
            }

            @media screen and (max-width: $bp-medium) {
                width: 100%;
            }
        }
    }
}
</style>
